import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { config } from 'app/config';
import { SimpleForm, SimpleFormGroup, themes, Dialog } from 'libs/ui';
import { Content, Header, Info, GrayInfo } from './benefit-set-form.styled';

export const BenefitSetForm = (props) => {
  const { working } = props;
  const [reason, setReason] = useState('');
  const [invalid, setInvalid] = useState(false);
  const benefitReasons = config.benefit_reasons;
  const withReasons = benefitReasons !== undefined && benefitReasons.length > 0;
  const { t } = useTranslation();

  /**
   * make action
   * @param {*} event
   */
  const action = (event) => {
    if (event) {
      event.preventDefault();
    }
    if (reason) {
      props.action({ reason });
      // props.close();
    } else {
      setInvalid(true);
    }
  };

  /**
   * change inputs
   * @param {*} e
   * @returns
   */
  const change = (e) => setReason(e.target.value);

  /**
   * get optopns for reasons select
   * @returns
   */
  const getOptionsEl = () => {
    if (!withReasons) {
      return null;
    }
    return benefitReasons.map((el, idx) => {
      return (
        <option key={idx} value={el}>
          {el}
        </option>
      );
    });
  };

  const optionsEl = getOptionsEl();

  return (
    <Dialog
      w={'480px'}
      id="dialog-benefit-set-form"
      align="right"
      buttons={[
        { title: t('buttons.Отменить'), onClick: props.close },
        { title: t('buttons.Сохранить'), onClick: action, theme: themes.blue, disabled: working, working },
      ]}
    >
      <Content>
        <Header>{t('form.Льгота')}</Header>
        <Info>{t('form.Внесите причину предоставления льготы и нажмите «Сохранить»')}</Info>
        <SimpleForm $invalid={invalid} onSubmit={action}>
          <SimpleFormGroup>
            <label htmlFor="benefit_reason">{t('form.Причина')}:</label>
            <input id="benefit_reason" type="text" onChange={change} value={reason} placeholder={t('form.Введите причину')} />
          </SimpleFormGroup>
          {withReasons && (
            <SimpleFormGroup>
              <GrayInfo>{t('form.Измените или выберите из списка')}</GrayInfo>
              <select defaultValue={''} onChange={change}>
                <option key="novalue" value="">
                  {t('form.выберите причину')}
                </option>
                {optionsEl}
              </select>
            </SimpleFormGroup>
          )}
        </SimpleForm>
      </Content>
    </Dialog>
  );
};
